import api from "./api";

// Atencion: es el punto de partida del proceso. Sus servicios se registran en
// atenciondetalle.
const atencionService = {
    // Atenciones con los filtros principales de la navegabilidad: persona y
    // rango de fechas (las fechas van en yyyy-MM-dd).
    getsAtencionView: async (filtros = {}) => {
        const response = await api.get("/Atencion/GetsAtencionView", {
            params: {
                persona: filtros.persona || "",
                fechaInicio: filtros.fechaInicio || null,
                fechaFin: filtros.fechaFin || null,
                idFilial: filtros.idFilial || 0,
            },
        });
        return response.data.data || [];
    },

    getsAtencionViewPorPersona: async (idPersona) => {
        const response = await api.get("/Atencion/GetsAtencionViewPorPersona", { params: { idPersona } });
        return response.data.data || [];
    },

    addUpdateAtencion: async (atencion) => {
        const response = await api.post("/Atencion/AddUpdateAtencion", atencion);
        return response.data.data;
    },

    // Anula la atencion: queda con estado Anulado, sin borrarse.
    anularAtencion: async (idAtencion) => {
        const response = await api.post("/Atencion/AnularAtencion?idAtencion=" + idAtencion);
        return response.data.data;
    },

    deleteAtencion: async (idAtencion) => {
        const response = await api.post("/Atencion/DeleteAtencion?idAtencion=" + idAtencion);
        return response.data.data;
    },

    // Servicios prestados en la atencion.
    getsAtencionDetallePorAtencion: async (idAtencion) => {
        const response = await api.get("/AtencionDetalle/GetsAtencionDetallePorAtencion", {
            params: { idAtencion },
        });
        return response.data.data || [];
    },

    addAtencionDetalle: async (detalle) => {
        const response = await api.post("/AtencionDetalle/AddAtencionDetalle", detalle);
        return response.data.data;
    },

    deleteAtencionDetalle: async (idAtencionDetalle) => {
        const response = await api.post("/AtencionDetalle/DeleteAtencionDetalle?idAtencionDetalle=" + idAtencionDetalle);
        return response.data.data;
    },
};

export default atencionService;
